import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {GridGetService, GridServiceParams, GridServiceResponse} from "../../shared/model/page-grid";
import {catchError, Observable} from "rxjs";
import {removeEmptyParams} from "../../../infrastructure/helper/remove-empty-params";
import {FmsInvoiceResponse} from "../model/fms-invoice-model";
import moment from "moment";

@Injectable({
  providedIn: 'root'
})
export class FmsInvoiceGridService implements GridGetService<FmsInvoiceResponse> {
  private readonly baseUrl = 'dbov2/fms-invoice/search';
  private readonly http = inject(HttpClient);

  private transformToTitleCase(value?: string): string {
    const trimmedValue = value?.trim();
    return trimmedValue
    ? trimmedValue.charAt(0).toUpperCase() + trimmedValue.slice(1)
      : '';
  }

  getItems({filters, page, sort}: GridServiceParams): Observable<GridServiceResponse<FmsInvoiceResponse>> {
    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: this.transformToTitleCase(sort?.active),
      orderKey: sort?.direction || '',

      InvoiceNumber: filters?.['invoiceNumber'] ?? '',
      InvoiceRecordLocator: filters?.['invoiceRecordLocator'] ?? '',
      TripNumber: filters?.['tripNumber'] ?? '',
      ClientName: filters?.['clientName'] ?? '',
      IssueDateFrom: filters?.['issueDateFrom'] ? moment(filters?.['issueDateFrom']).format('YYYY-MM-DD') : '',
      IssueDateTo: filters?.['issueDateTo'] ? moment(filters?.['issueDateTo']).format('YYYY-MM-DD') : '',
      BranchNumber: filters?.['branchNumber'] ?? '',
      TravelTypeId: filters?.['travelTypeId'] ?? '',
      ExternalTravelServiceTypeId: filters?.['externalTravelServiceTypeId'] ?? '',
      IsMor: filters?.['isMor'] ?? '',
      VendorName: filters?.['vendorName'] ?? '',
      AgentName: filters?.['agentName'] ?? '',
      IsSyncedToErp: filters?.['isSyncedToErp'] ?? '',
      InvoiceType: filters?.['invoiceType'] ?? '',
      DataSourceId: filters?.['dataSourceId'] ?? '',
      InvoiceGroup: filters?.['invoiceGroup'] ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<FmsInvoiceResponse>>(`${this.baseUrl}`, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
